<template>
  <div class="rules">
    <h2>活动规则</h2>
    <button @click="handleCancel" class="x"></button>
    <div class="rules-body">
      <el-scrollbar>
        <h4>创建词条格式</h4>
        <ul>
          <li>【文案】标题需要控制在20个汉字以内，内容在350个汉字以内。</li>
          <li>
            【图片】格式支持：JPG，JPEG，PNG，GIF，建议尺寸800X450，大小在2MB以内。
          </li>
        </ul>
        <h4>创作要求</h4>
        <ul>
          <li>
            1、玩家可以围绕DOTA2内的梗或故事内容进行词条创作，所有词条内容必须由玩家自行撰写，不可剽窃他人内容，如被发现，将取消参与活动资格。
          </li>
          <li>
            2、严禁暴力、反动、色情以及一切违反国家法律内容，并且所有带节奏、不和谐的内容都将不会通过审核。
          </li>
          <li>
            3、词条一经投稿，且被审核通过，后续完美世界电竞官方有合理使用其内容的权利，包括但不限于在官网、线上线下活动、微博、微信等推广渠道中署名使用。
          </li>
          <li>
            4、完美世界电竞官方保留对词条中违规或被投诉或不合适的内容进行删除、修改的权利。
          </li>
          <li>
            5、活动禁止刷票点赞等破坏活动公平原则的行为，情节严重者将被取消活动参与资格。
          </li>
          <li>
            6、玩家们可以随时通过完美世界官方客服举报反馈活动中的违规或不合适的内容，查实后会对违规内容进行删除。
          </li>
          <li>7、活动时间：8月20日12:00-9月18日12:00。</li>
          <li>
            8、每创建1条新词条并通过审核，
            即可获得30积分。创建的词条每获得1个赞，即可获得1积分。
          </li>
          <li>
            9、积分相同时，按获得贡献值时间的先后排序，获得时间靠前的玩家排在前列。
          </li>
        </ul>
        <h4>奖品说明</h4>
        <ul>
          <li>
            1、排行榜获得的奖品可在<span>我要创作</span>页面点击“<span>查看我的奖品</span>”中查看。
          </li>
          <li>
            2、系统将于<span>2020年9月18日</span>23点59分锁定排行榜，并于次日根据排名发放排名奖励。
          </li>
          <li>
            3、所有实物奖品的收货信息填写截止于<span>2020年9月27日</span>23点59分，逾期未填写信息将自动视为放弃。
          </li>
          <li>
            4、实体奖品将于收货信息填写截止日期后的<span>15个工作日</span>内发放。
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../../store/mutation-types'
import { Scrollbar } from 'element-ui'
export default {
  components: {
    elScrollbar: Scrollbar,
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    handleCancel() {
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.rules {
  position: relative;
  width: 986px;
  margin: 0 auto;
  height: 776px;
  padding-top: 102px;
  font-size: 14px;
  background-image: url('https://img.dota2.com.cn/file/5f/00/5f0095a98ce0b4738372608125ee8b841596100336.png');
  h2 {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
    margin-bottom: 30px;
    color: #c3f1f6;
    text-align: center;
  }
  h4 {
    color: #b5f0fa;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .rules-body {
    padding: 0 70px 0 100px;
    color: #c7d1da;
    ul {
      padding-right: 30px;
      li {
        margin-bottom: 16px;
        line-height: 150%;
        span {
          color: #b5f0fa;
        }
      }
    }
  }
  .x {
    position: absolute;
    right: 0px;
    top: 62px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-image: url('../../assets/close.png');
  }
}

/deep/ .el-scrollbar__wrap {
  height: 530px;
  overflow-x: hidden;
}
/deep/ .el-scrollbar__thumb {
  background-color: #b5f0fa;
  left: 0px;
}
/deep/ .el-scrollbar__bar {
  opacity: 1;
  width: 5px;
}
</style>
